import type from './CompanyRightsTypes.type';

const initialState = {
  companyRightsData: {},
  excludesCompanyModules: false,
};

const CompanyRightsReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_COMPANY_RIGHTS:
      return {
        ...state,
        companyRightsData: action.payload,
      };
    case type.FETCH_COMPANY_RIGHTS_EXCLUDES:
      return {
        ...state,
        excludesCompanyModules: action.payload,
      };
    default:
      return state;
  }
};

export default CompanyRightsReducer;
